import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('cookie_consent');
    if (!stored) {
      setVisible(true);
    }
  }, []);

  function handleAccept() {
    localStorage.setItem('cookie_consent', 'accepted');
    if (window.gtag) {
      window.gtag('consent', 'update', { analytics_storage: 'granted' });
    }
    setVisible(false);
  }

  function handleDecline() {
    localStorage.setItem('cookie_consent', 'declined');
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black text-white px-6 py-5 md:px-12 flex flex-col md:flex-row items-center gap-4 md:gap-8 shadow-lg">
      <p className="text-sm leading-relaxed flex-1 text-center md:text-left">
        We use cookies to analyse traffic and improve your experience.{' '}
        <Link to="/privacy-policy" className="underline hover:text-gray-300">
          Learn more
        </Link>
        .
      </p>
      <div className="flex gap-3 shrink-0">
        <button
          onClick={handleDecline}
          className="px-5 py-2 text-sm font-semibold border border-white rounded hover:bg-white hover:text-black transition-colors"
        >
          Decline
        </button>
        <button
          onClick={handleAccept}
          className="px-5 py-2 text-sm font-semibold bg-white text-black rounded hover:bg-gray-200 transition-colors"
        >
          Accept
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;
